module.exports = __webpack_public_path__ + "img/dashboard_white.0c5bf73c.svg";